import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import React from "react";
import { COUNTRIES_LIST, STATE_LIST } from "../../../../../../constants";
import { RELATIONSHIP_WITH_PATIENT } from "../../../../../../constants/provider/add-new-patient";
import { PatientInsuranceSubscriberGenderEnum } from "../../../../../../services";
import CustomDatePicker from "../../../../../CustomDatePicker";
import CustomSelect from "../../../../../CustomSelect";
import Input from "../../../../../Input";
import MaskInput from "../../../../../MaskInput";
import dayjs from "dayjs";
import { getInsuranceFieldError } from "./insurance-validation";
interface SubscriberInformationProps {
  ind: number;
  formik: any; // Replace 'any' with the specific type of your formik object if available
  patientData: any;
}
const SubscriberInformation: React.FC<SubscriberInformationProps> = ({
  formik,
  ind,
  patientData,
}) => {
  const { values, handleChange, handleBlur, setFieldValue, touched, errors } =
    formik;

  const setSelfContactDetails = (k: string) => {
    setFieldValue(
      k + "subscriberMobileNumber",
      formik.values.mobileNumber ?? patientData?.mobileNumber
    );
    setFieldValue(
      k + "subscriberFirstName",
      formik.values.firstName ?? patientData?.firstName
    );
    setFieldValue(
      k + "subscriberLastName",
      formik.values.lastName ?? patientData?.lastName
    );
    setFieldValue(
      k + "subscriberMiddleName",
      formik.values.middleName ?? patientData?.middleName
    );
    setFieldValue(
      k + "subscriberBirthDate",
      formik.values.birthDate ?? patientData?.birthDate
    );
    setFieldValue(
      k + "subscriberAddress",
      formik.values.address ?? patientData?.address
    );
    setFieldValue(
      k + "subscriberGender",
      formik.values.gender ?? patientData?.gender
    );
    setFieldValue(
      k + "subscriberSsn",
      formik.values.ssn ?? patientData?.ssn ?? undefined
    );
  };

  return (
    <Box sx={{ mx: "auto", mt: 4 }}>
      <Grid container spacing={2}>
        <Grid item xs={3}>
          <CustomSelect
            value={
              values.patientInsurances?.[ind]?.insuredRelationshipWithPatient
            }
            onChange={(value) => {
              if (value === "SELF") {
                setSelfContactDetails(`patientInsurances[${ind}].`);
              } else {
                setFieldValue(`patientInsurances[${ind}]`, {
                  ...values.patientInsurances?.[ind],
                  subscriberMobileNumber: null,
                  subscriberFirstName: null,
                  subscriberLastName: null,
                  subscriberMiddleName: null,
                  subscriberBirthDate: null,
                  subscriberAddress: null,
                  subscriberGender: null,
                  subscriberSsn: null,
                });
              }

              setFieldValue(
                `patientInsurances[${ind}].insuredRelationshipWithPatient`,
                value
              );
            }}
            disableSortOptions
            label="Relationship to Insured"
            options={RELATIONSHIP_WITH_PATIENT}
          />
        </Grid>
        <Grid item xs={3}>
          <Input
            label="First Name"
            textFieldProps={{
              disabled:
                values.patientInsurances?.[ind]
                  ?.insuredRelationshipWithPatient === "SELF",
              name: `patientInsurances[${ind}].subscriberFirstName`,
              value: values.patientInsurances?.[ind]?.subscriberFirstName || "",
              onChange: handleChange,
              onBlur: handleBlur,
              // placeholder: "First Name",
            }}
            error={getInsuranceFieldError(formik, ind, "subscriberFirstName")}
          />
        </Grid>
        <Grid item xs={3}>
          <Input
            label="Middle Name"
            textFieldProps={{
              disabled:
                values.patientInsurances?.[ind]
                  ?.insuredRelationshipWithPatient === "SELF",
              name: `patientInsurances[${ind}].subscriberMiddleName`,
              value:
                values.patientInsurances?.[ind]?.subscriberMiddleName || "",
              onChange: handleChange,
              onBlur: handleBlur,
              // placeholder: "Middle Name",
            }}
          />
        </Grid>
        <Grid item xs={3}>
          <Input
            label="Last Name"
            textFieldProps={{
              disabled:
                values.patientInsurances?.[ind]
                  ?.insuredRelationshipWithPatient === "SELF",
              name: `patientInsurances[${ind}].subscriberLastName`,
              value: values.patientInsurances?.[ind]?.subscriberLastName || "",
              onChange: handleChange,
              onBlur: handleBlur,
              // placeholder: "Last Name",
            }}
            error={getInsuranceFieldError(formik, ind, "subscriberLastName")}
          />
        </Grid>
        <Grid item xs={3}>
          <CustomDatePicker
            maxDate={dayjs(new Date())}
            disabled={
              values.patientInsurances?.[ind]
                ?.insuredRelationshipWithPatient === "SELF"
            }
            label="Date of Birth"
            value={values.patientInsurances?.[ind]?.subscriberBirthDate}
            onChange={(value) => {
              setFieldValue(
                `patientInsurances[${ind}].subscriberBirthDate`,
                value
              );
            }}
            error={getInsuranceFieldError(formik, ind, "subscriberBirthDate")}
          />
        </Grid>
        <Grid item xs={3}>
          <CustomSelect
            label="Gender"
            value={values.patientInsurances?.[ind]?.subscriberGender}
            options={Object.entries(PatientInsuranceSubscriberGenderEnum).map(
              ([key, value]) => ({
                value: value,
                label: key,
              })
            )}
            readOnly={
              values.patientInsurances?.[ind]
                ?.insuredRelationshipWithPatient === "SELF"
            }
            onChange={(value) =>
              setFieldValue(`patientInsurances[${ind}].subscriberGender`, value)
            }
            // placeholder="Gender"
            error={getInsuranceFieldError(formik, ind, "subscriberGender")}
          />
        </Grid>
        <Grid item xs={3}>
          <Input
            label="Social Security Number"
            textFieldProps={{
              disabled:
                values.patientInsurances?.[ind]
                  ?.insuredRelationshipWithPatient === "SELF",
              name: `patientInsurances[${ind}].subscriberSsn`,
              value: values.patientInsurances?.[ind]?.subscriberSsn || "",
              onChange: handleChange,
              onBlur: handleBlur,
              // placeholder: "Social Security Number",
            }}
          />
        </Grid>
        <Grid item xs={3}>
          <MaskInput
            mask={"(999) 999-9999"}
            label="Mobile Number"
            disabled={
              values.patientInsurances?.[ind]
                ?.insuredRelationshipWithPatient === "SELF"
            }
            name="subscriberMobileNumber"
            onBlur={formik.handleBlur}
            // placeholder="Enter Number"
            value={
              values.patientInsurances?.[ind]?.subscriberMobileNumber || ""
            }
            onChange={(e) =>
              setFieldValue(
                `patientInsurances[${ind}].subscriberMobileNumber`,
                e.target.value
              )
            }
            error={
              touched?.subscriberMobileNumber && errors?.subscriberMobileNumber
            }
          />
        </Grid>
        {/* <Grid item xs={12}>
          <Typography fontWeight={500}>Subscriber Address</Typography>
        </Grid> */}
        <Grid item xs={6}>
          <Input
            label="Address Line 1"
            textFieldProps={{
              disabled:
                values.patientInsurances?.[ind]
                  ?.insuredRelationshipWithPatient === "SELF",
              name: `patientInsurances[${ind}].subscriberAddress.line1`,
              value:
                values.patientInsurances?.[ind]?.subscriberAddress?.line1 || "",
              onChange: handleChange,
              onBlur: handleBlur,
              // placeholder: "Enter Address Line 1",
            }}
            error={getInsuranceFieldError(
              formik,
              ind,
              "subscriberAddress.line1"
            )}
          />
        </Grid>
        <Grid item xs={6}>
          <Input
            label="Address Line 2"
            textFieldProps={{
              disabled:
                values.patientInsurances?.[ind]
                  ?.insuredRelationshipWithPatient === "SELF",
              name: `patientInsurances[${ind}].subscriberAddress.line2`,
              value:
                values.patientInsurances?.[ind]?.subscriberAddress?.line2 || "",
              onChange: handleChange,
              onBlur: handleBlur,
              // placeholder: "Enter Address Line 2",
            }}
          />
        </Grid>
        <Grid item xs={3}>
          <Input
            label="City"
            textFieldProps={{
              disabled:
                values.patientInsurances?.[ind]
                  ?.insuredRelationshipWithPatient === "SELF",
              name: `patientInsurances[${ind}].subscriberAddress.city`,
              value:
                values.patientInsurances?.[ind]?.subscriberAddress?.city || "",
              onChange: handleChange,
              onBlur: handleBlur,
              // placeholder: "Enter City",
            }}
            error={getInsuranceFieldError(
              formik,
              ind,
              "subscriberAddress.city"
            )}
          />
        </Grid>
        <Grid item xs={3}>
          <CustomSelect
            label="State"
            value={values.patientInsurances?.[ind]?.subscriberAddress?.state}
            options={STATE_LIST}
            onChange={(value) =>
              setFieldValue(
                `patientInsurances[${ind}].subscriberAddress.state`,
                value
              )
            }
            readOnly={
              values.patientInsurances?.[ind]
                ?.insuredRelationshipWithPatient === "SELF"
            }
            // placeholder="Select State"
            error={getInsuranceFieldError(
              formik,
              ind,
              "subscriberAddress.state"
            )}
          />
        </Grid>
        <Grid item xs={3}>
          <CustomSelect
            readOnly={
              values.patientInsurances?.[ind]
                ?.insuredRelationshipWithPatient === "SELF"
            }
            value={values.patientInsurances?.[ind]?.subscriberAddress?.country}
            disableSortOptions
            options={COUNTRIES_LIST}
            onChange={(value) =>
              setFieldValue(
                `patientInsurances[${ind}].subscriberAddress.country`,
                value
              )
            }
            label="Country"
            // placeholder="Select Country"
            error={getInsuranceFieldError(
              formik,
              ind,
              "subscriberAddress.country"
            )}
          />
        </Grid>
        <Grid item xs={3}>
          <Input
            label="ZIP Code"
            textFieldProps={{
              disabled:
                values.patientInsurances?.[ind]
                  ?.insuredRelationshipWithPatient === "SELF",
              name: `patientInsurances[${ind}].subscriberAddress.zipcode`,
              value: (() => {
                const d = (
                  values.patientInsurances?.[ind]?.subscriberAddress?.zipcode ||
                  ""
                )
                  .replace(/\D/g, "")
                  .slice(0, 9);
                return d.length > 5 ? `${d.slice(0, 5)}-${d.slice(5)}` : d;
              })(),
              onChange: (e) => {
                const digits = e.target.value.replace(/\D/g, "").slice(0, 9);
                const val =
                  digits.length > 5
                    ? `${digits.slice(0, 5)}-${digits.slice(5)}`
                    : digits;
                setFieldValue(
                  `patientInsurances[${ind}].subscriberAddress.zipcode`,
                  val
                );
              },
              onBlur: handleBlur,
              inputProps: { maxLength: 10 },
            }}
            error={getInsuranceFieldError(
              formik,
              ind,
              "subscriberAddress.zipcode"
            )}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default SubscriberInformation;
